var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 5,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.8.193a.7.7 0 0 0-.964 0L4.5 3.412 1.164.192a.7.7 0 0 0-.964 0 .64.64 0 0 0 0 .931l3.818 3.684a.7.7 0 0 0 .964 0L8.8 1.123a.64.64 0 0 0 0-.93",
  opacity: 0.8
})));
export default SvgArrowDown;